export default __webpack_public_path__ + "static/media/my_emma.240a9d7a.png";